<template>
  <v-dialog v-model="show" max-width="500">
    <v-card>
      <v-card-title>Create new Trade</v-card-title>
      <v-card-text class="pb-0 pt-4">
        <v-text-field
          outlined
          flat
          large
          label="Trade Name"
          v-model="form.name"
          :error-messages="form.$getError('name')"
        />
      </v-card-text>
      <v-card-actions class="px-6 pb-6 pt-0">
        <div class="flex-grow-1"></div>
        <v-btn
          depressed
          color="primary"
          class="px-10"
          :loading="form.$busy"
          @click="onAddTrade"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'
import { mapActions } from 'vuex'
import eventBus from '@/services/eventBus'

export default {
  name: 'CreateTradeForm',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: this.value,
      form: new Form({
        name: '',
      }),
    }
  },

  methods: {
    ...mapActions({
      createTrade: 'trade/createTrade',
    }),

    onAddTrade() {
      this.addTrade().catch((err) => {
        this.form.$busy = false
        if (err.response.status === 422) {
          this.form.$setErrors(err.response.data.errors)
        }
      })
    },

    async addTrade() {
      this.form.$busy = true
      await this.createTrade(this.form.$data())
        .then((res) => {
          this.form.$setErrors({})

          this.$emit('onTradeCreated')

          eventBus.$emit('snackbar', {
            message: 'New trade added!',
            color: 'success',
          })

          this.form.$reset()
        })
        .catch((err) => {
          this.form.$setErrors(err.data.errors)

          eventBus.$emit('snackbar', {
            message: err.data.message,
            color: 'red',
          })
        })
        .finally(() => {
          this.form.$busy = false
        })
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    },
  },
}
</script>
